import {
  AbstractLoadStrategy,
  AudioLoadStrategy,
  ImageLoadStrategy,
  MediaElementLoadStrategy,
  VideoLoadStrategy,
  XhrLoadStrategy,
  XhrResponseType,
  Loader,
  Resource,
  ResourceType,
  ResourceState
} from 'resource-loader'

export const resourceLoader = {
  AbstractLoadStrategy,
  AudioLoadStrategy,
  ImageLoadStrategy,
  XhrResponseType,
  MediaElementLoadStrategy,
  VideoLoadStrategy,
  XhrLoadStrategy,
  Loader,
  Resource,
  ResourceType,
  ResourceState
}